const principles = [
  {
    icon: "ri-scan-line",
    title: "还原原稿细节",
    desc: "重视线条与网点的层次，让画面经得起放大，留住作者原本的笔意。",
  },
  {
    icon: "ri-timer-line",
    title: "慢下来的阅读",
    desc: "不追求刷屏式快感，用接近翻书的节奏，找回读纸质漫画时的专注。",
  },
  {
    icon: "ri-heart-line",
    title: "守护复古风格",
    desc: "偏爱印刷年代的气味，认真挑选有味道的作品，让复古不沦为噱头。",
  },
];

const stats = [
  { value: "2019", label: "纸盒创立" },
  { value: "600+", label: "收录作品" },
  { value: "24w", label: "累计读者" },
  { value: "12", label: "主题栏目" },
];

export default function About() {
  return (
    <section id="about" className="paper-bg">
      <div className="container-paper py-14 md:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          {/* 品牌故事 */}
          <div>
            <span className="inline-flex items-center gap-2 text-xs tracking-[0.18em] text-primary-600">
              <i className="ri-box-3-line text-sm leading-none" aria-hidden="true"></i>
              关于纸盒
            </span>
            <h2 className="mt-3 font-display text-3xl leading-tight text-foreground-950 md:text-4xl">
              一只纸盒，
              <br />
              装下被遗忘的翻阅感
            </h2>
            <p className="mt-5 text-sm leading-8 text-foreground-600">
              纸盒漫画网源于一个简单的念头：如今看漫画大多停留在发光的屏幕上，而那种把旧书摊在膝上、
              指尖压过纸张、让网点与纸纹在灯下泛黄的触感，正在慢慢变少。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-600">
              于是我们把「纸质原稿质感」与「实体书感」做成了一套完整的阅读体验——
              从泛黄的纸色、印刷的网点，到翻页的节奏。我们希望来到这里的人，能重新找回那种
              不慌不忙、一页一页往下看的专注。
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="flex min-w-[110px] flex-col rounded-lg border border-background-300 bg-background-50 px-5 py-4"
                >
                  <span className="font-display text-2xl text-primary-600">{s.value}</span>
                  <span className="mt-1 text-xs text-foreground-500">{s.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 内容原则 */}
          <div>
            <div className="flex items-center justify-between">
              <h3 className="font-display text-2xl text-foreground-950">我们坚持的内容原则</h3>
              <span className="seal hidden text-xs sm:inline-flex">始于热爱</span>
            </div>
            <div className="mt-6 space-y-4">
              {principles.map((p) => (
                <div
                  key={p.title}
                  className="flex gap-5 rounded-lg border border-background-300 bg-background-50 p-5 md:p-6"
                >
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                    <i className={`${p.icon} text-xl leading-none`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h4 className="font-display text-lg text-foreground-950">{p.title}</h4>
                    <p className="mt-1.5 text-sm leading-7 text-foreground-600">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}